<template>
  <div class="page">
    <mu-container>
      <mu-form ref="form" :model="form" class="mu-demo-form">
        <mu-form-item prop="name">
          <div slot="label">
            <label class="label-required">姓名</label>
          </div>
          <mu-text-field v-model="form.student_name"></mu-text-field>
        </mu-form-item>
        <mu-form-item prop="idcard">
          <div slot="label">
            <label class="label-required">身份证号</label>
          </div>
          <mu-text-field v-model="form.idcard"></mu-text-field>
        </mu-form-item>
        <mu-form-item>
          <mu-button style="flex: 1" color="primary" @click="submit"> 提交 </mu-button>
        </mu-form-item>
      </mu-form>
    </mu-container>
    <!-- <mu-expansion-panel
      v-for="(item, index) in list"
      :key="index"
      :expand="panel === index"
      @change="toggle(index)"
    >
      <div slot="header">{{ item.name }}</div>
      <div class="img" @click="previewImg(item.path)">
        <img :src="item.path" class="img" />
      </div>
    </mu-expansion-panel> -->
    <div class="certList">
      <div class="certItem" v-for="(item, index) in list" :key="index" @click="goCertTable(item)">
        <div class="certName">{{ item.name }}</div>
        <mu-divider class="divider"></mu-divider>
      </div>
    </div>
  </div>
</template>

<script>
import request from "@/utils/request";
import { ImagePreview, Toast } from "vant";

export default {
  data() {
    return {
      panel: "",
      list: [],
      form: {
        student_name: "",
        idcard: "",
      },
    };
  },
  created() {},
  mounted() {},
  methods: {
    toggle(panel) {
      this.panel = panel === this.panel ? "" : panel;
    },
    async submit() {
      try {
        let res = await request({
          url: "/v1/api/cert/queryCertNo",
          method: "get",
          noToast: true,
          params: {
            platform: "wechat",
            ...this.form,
          },
        });
        this.list = res.map((item) => {
          return {
            id: item.id,
            name: item.cert_no,
            path: item.cert_pic_url,
          };
        });
        if(this.list.length == 0) {
          Toast('暂无结业证书')
        }
      } catch (error) {
        Toast(error.error);
      }
    },
    // 验证身份证
    checkCode(val) {
      if (val.length > 15) {
        const p = /^[1-9]\d{5}(18|19|20)\d{2}((0[1-9])|(1[0-2]))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/;
        const factor = [7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2];
        const parity = [1, 0, "X", 9, 8, 7, 6, 5, 4, 3, 2];
        const code = val.substring(17);
        if (p.test(val)) {
          let sum = 0;
          for (let i = 0; i < 17; i++) {
            sum += val[i] * factor[i];
          }
          if (parity[sum % 11] == code.toUpperCase()) {
            return true;
          }
        }
        return false;
      } else {
        return /(^\d{8}(0\d|10|11|12)([0-2]\d|30|31)\d{3}$)|(^\d{6}(18|19|20)\d{2}(0\d|10|11|12)([0-2]\d|30|31)\d{3}(\d|X|x)$)/.test(
          val
        );
      }
    },
    previewImg(img) {
      ImagePreview([img]);
    },
    // 跳转到证书电子表格
    goCertTable(item) {
      this.$router.push({ path: '/certificateTableNew', query: { id: item.id } })
    }
  },
};
</script>
<style lang="scss" scoped>
.page {
  padding: 20px;
}
.img {
  width: 100%;
  height: auto;
}
.certList{
  width: 100%;
  box-shadow: 0 0 4px #ccc;
  padding: 1px 16px 0;
  .certItem{
    margin: 10px 0;
    display: flex;
    align-items: center;
    justify-content: space-between;
    position: relative;
    .certName{
      padding-bottom: 10px;
    }
    .divider{
      position: absolute;
      bottom: 0;
    }
  }
}
</style>
